// extracted by mini-css-extract-plugin
module.exports = {"pill":"F-pill-pill-3amHt","small":"F-pill-small-ICaVr","medium":"F-pill-medium-N4Aac","large":"F-pill-large-XlAr1","interactive":"F-pill-interactive-1G9Li"};